import { useState, useLayoutEffect, useContext } from 'react';

import NodeManagerContext from './NodeManagerContext';
import sortNodes from './sortNodes';

export const useOrderedNodes = (sorter = sortNodes) => {
  const [matches, setMatches] = useState([]);
  const { nodes, namespace } = useContext(NodeManagerContext);

  useLayoutEffect(() => {
    const sorted = sorter(Object.keys(nodes).map((k) => nodes[k]));
    setMatches(sorted);
  }, [nodes, namespace]);

  return matches;
};
